import { Button, Divider, TextField, Typography } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import AddIcon from "@material-ui/icons/Add";
import AddBox from "@material-ui/icons/AddBox";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import SearchIcon from "@material-ui/icons/Search";
import { Form, Formik } from "formik";
import MaterialTable from "material-table";
import { useAppContext } from "../../../../../context/AuthContext";
import LabelsContext from "../../../../../lang/LabelsContext";
import { tableIcons } from "../../../../system/material-table-utils/MaterialTableUtils";
import AuthorService, { AuthorServiceType } from "./AuthorService";
import useStyles from "./AuthorsStyle";
import AuthorsModal from "./modal/AuthorsModal";

export default function Authors({ article, setArticle, handleNext, handleBack }: any) {
  const classes = useStyles();
  const { authData } = useAppContext();
  const { Labels } = LabelsContext();
  const {
    openModal,
    closeModal,
    deleteAuthor,
    shiftUpElement,
    shiftDownElement,
    searchAuthorList,
    selectedSearchListAuthor,
    setSelectedSearchListAuthor,
    selectedAddedListAuthor,
    setSelectedAddedListAuthor,
    addedAuthorList,
    setAddedAuthorList,
    open,
    setForceRender,
    forceRender,
    authorSave,
    articleSave,
    getSearchAuthorList,
    parseAuthorName,
    searchDisable,
    setOpen,
    onEnterSearch,
  }: AuthorServiceType = AuthorService({ article });

  return (
    <>
      <CssBaseline />
      <div className={classes.container}>
        <Formik
          initialValues={{
            firstname: "",
            lastname: "",
            email: "",
            orcid: "",
          }}
          onSubmit={(values) => articleSave(values, article, setArticle, handleNext)}
        >
          {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Form
              onKeyDown={(e) =>
                onEnterSearch(e, {
                  firstName: values.firstname,
                  lastName: values.lastname,
                  email: values.email,
                  orcid: values.orcid,
                })
              }
            >
              <Grid container spacing={1} justify="space-evenly">
                <Grid item className={classes.contentContainer} xs={12} sm={7}>
                  <Typography className={classes.cardHeader}>{Labels.SEARCH_AUTHOR}</Typography>
                  <Divider />
                  <Grid className={classes.gridRow}>
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      margin="normal"
                      id="firstname"
                      name="firstname"
                      label={Labels.FIRSTNAME}
                      value={values?.firstname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.firstname && Boolean(errors?.firstname)}
                      helperText={touched?.firstname && errors?.firstname}
                      fullWidth
                      inputProps={{ maxLength: 50 }}
                    />
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      margin="normal"
                      id="lastname"
                      name="lastname"
                      label={Labels.LASTNAME}
                      value={values?.lastname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.lastname && Boolean(errors?.lastname)}
                      helperText={touched?.lastname && errors?.lastname}
                      fullWidth
                      inputProps={{ maxLength: 50 }}
                    />
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      margin="normal"
                      id="email"
                      name="email"
                      label={Labels.EMAIL}
                      value={values?.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.email && Boolean(errors?.email)}
                      helperText={touched?.email && errors?.email}
                      fullWidth
                      inputProps={{ maxLength: 50 }}
                    />
                    <TextField
                      className={classes.input}
                      variant="outlined"
                      margin="normal"
                      id="orcid"
                      name="orcid"
                      label={Labels.ORCID}
                      value={values?.orcid}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched?.orcid && Boolean(errors?.orcid)}
                      helperText={touched?.orcid && errors?.orcid}
                      fullWidth
                      inputProps={{ maxLength: 50 }}
                    />
                    <IconButton
                      edge="start"
                      color="primary"
                      aria-label="edit"
                      disabled={searchDisable}
                      onClick={(e: any) => {
                        getSearchAuthorList({
                          firstName: values.firstname,
                          lastName: values.lastname,
                          email: values.email,
                          orcid: values.orcid,
                        });
                      }}
                    >
                      <SearchIcon fontSize="large" />
                    </IconButton>
                  </Grid>
                  <Divider />
                  <Grid className={classes.dividerContainer} item justifyContent="center" alignItems="center">
                    {!searchAuthorList && (
                      <Typography className={classes.placeholderText}>{Labels.NO_RESULTS}</Typography>
                    )}
                  </Grid>
                  {searchAuthorList && (
                    <MaterialTable
                      icons={tableIcons}
                      columns={[
                        { field: "firstName", title: Labels.FIRSTNAME },
                        { field: "lastName", title: Labels.LASTNAME },
                        { field: "institute", title: Labels.INSTITUTE },
                        {
                          field: "orcid",
                          title: Labels.ORCID,
                        },
                      ]}
                      title={
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<AddIcon />}
                          onClick={(e: any) => {
                            setSelectedAddedListAuthor({});
                            openModal();
                          }}
                        >
                          {Labels.ADD}
                        </Button>
                      }
                      data={searchAuthorList}
                      options={{
                        actionsColumnIndex: -1,
                        pageSize: 10,
                      }}
                      localization={{
                        toolbar: {
                          searchPlaceholder: "Filter",
                        },
                      }}
                      actions={[
                        {
                          icon: () => <AddBox />,
                          tooltip: Labels.ADD,
                          onClick: (event, rowData) => {
                            setSelectedSearchListAuthor(rowData);
                            openModal();
                          },
                        },
                      ]}
                    />
                  )}
                </Grid>
                <Grid className={classes.contentContainer} item xs={12} sm={4}>
                  <Typography className={classes.cardHeader}>{Labels.ADDED_AUTHORS}</Typography>
                  <Divider />
                  <div className={classes.demo}>
                    <List>
                      {addedAuthorList &&
                        addedAuthorList.map((row: any) => {
                          return (
                            <ListItem>
                              <IconButton
                                edge="start"
                                className={classes.arrowButton}
                                aria-label="down"
                                onClick={(e: any) => {
                                  setAddedAuthorList(shiftDownElement(addedAuthorList, row));
                                  setForceRender(forceRender + 1);
                                }}
                              >
                                <KeyboardArrowDownIcon />
                              </IconButton>
                              <IconButton
                                edge="start"
                                className={classes.arrowButton}
                                aria-label="up"
                                onClick={(e: any) => {
                                  setAddedAuthorList(shiftUpElement(addedAuthorList, row));
                                  setForceRender(forceRender + 1);
                                }}
                              >
                                <KeyboardArrowUpIcon />
                              </IconButton>
                              <ListItemText primary={parseAuthorName(row)} />
                              <ListItemSecondaryAction>
                                {authData?.user.email !== row.email && (
                                  <>
                                    <IconButton
                                      edge="start"
                                      aria-label="edit"
                                      className={classes.arrowButton}
                                      onClick={(e: any) => {
                                        setSelectedAddedListAuthor(row);
                                        openModal();
                                      }}
                                    >
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      edge="start"
                                      className={classes.arrowButton}
                                      aria-label="delete"
                                      onClick={(e: any) => {
                                        deleteAuthor(setAddedAuthorList, addedAuthorList, row);
                                      }}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </>
                                )}
                              </ListItemSecondaryAction>
                            </ListItem>
                          );
                        })}
                    </List>
                  </div>
                </Grid>
              </Grid>
              <div className={classes.buttons}>
                <Button variant="outlined" color="primary" onClick={handleBack} className={classes.button}>
                  {Labels.BACK}
                </Button>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>
                  {Labels.NEXT}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
        <Dialog
          open={open}
          onClose={() => {
            closeModal();
            setSelectedSearchListAuthor(undefined);
            setSelectedAddedListAuthor(undefined);
          }}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{Labels.AUTHOR}</DialogTitle>
          <AuthorsModal
            authorsProp={selectedSearchListAuthor! || selectedAddedListAuthor}
            authorSave={authorSave}
            setArticle={setArticle}
            article={article}
            setOpen={setOpen}
          />
        </Dialog>
      </div>
    </>
  );
}
